import type { AiValidationResult } from './ai-validation';

export interface SeoInsightKeywordItem {
  category: "top_priority" | "hidden_gem" | "trending" | "ai_recommendation";
  position: number;
  keyword: string;
  description: string | null;
  search_volume: number | null;
  competitors: number | null;
  kps: number | null;
  kps_raw: number | null;
}

export interface SeoInsight {
  id: number;
  product_id: number;
  landscape_id: number;
  keywords_analyzed: number;
  created_at: string;
  keywords: SeoInsightKeywordItem[];
  validation?: AiValidationResult | null;
}

export interface SeoInsightPending {
  status: "pending";
}

export type SeoInsightLatestResponse = SeoInsight | SeoInsightPending;

export function isSeoInsightPending(
  response: SeoInsightLatestResponse | undefined,
): response is SeoInsightPending {
  return !!response && "status" in response && response.status === "pending";
}

export interface SeoInsightListItem {
  id: number;
  created_at: string;
  keywords_analyzed: number;
}
